import { IconName, Stack } from '@optimus-web/core';
import { DateTime, LocalizedDateTime } from '@mews/framework';
import Notification from '../Notification';
import { NotificationType } from '../types';

interface SimpleNotificationProps {
    title?: string;
    text?: string;
    icon: IconName;
    createdDateTime?: DateTime;
    isSeen: boolean;
    onClick: () => void;
    type: NotificationType;
}

const SimpleNotification = ({ title, text, icon, createdDateTime, isSeen, onClick, type }: SimpleNotificationProps) => (
    <Notification label={title} icon={icon} isSeen={isSeen} onClick={onClick} type={type}>
        <Stack vertical>
            {text}
            <LocalizedDateTime dateTime={createdDateTime} />
        </Stack>
    </Notification>
);

export default SimpleNotification;
